export default [
  {
    path: "/fatura-ai",
    name: "fatura_ai",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "fatura_ai.baslik",
      yetki: { k: [1320002] },
    },
  },
  {
    path: "/fatura-ai/:uuid",
    name: "fatura_ai-edit",
    component: () => import("./EditView.vue"),
    meta: {
      public: false,
      title: "fatura_ai.detaylar",
      yetki: { k: [1320004] },
    },
  },
  {
    path: "/fatura-ai/gelir-list",
    name: "fatura_ai-gelir-list",
    component: () => import("./GelirList.vue"),
    meta: {
      public: false,
      title: "fatura_ai.gelir_listesi",
      yetki: { k: [1320002] },
    },
  },
]
